
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Contact Information</h3>

      <div class="row">
        <div class="col-md-12">
          If after reviewing the information included on this website you still have questions about the Settlement, please contact the Settlement Administrator directly using the contact information below.
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-12 text-center">
          Turkey Antitrust Litigation Helpline: 877-777-9637<br />
          By email: <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a><br />
          Or in writing to:<br />
          Turkey Antitrust Litigation<br />
          c/o A.B. Data, Ltd.<br />
          P.O. Box 173015<br />
          Milwaukee, WI  53217<br /><br />

          Remember to include “Turkey Antitrust Litigation” on any correspondence, envelope, and/or subject line.
        </div>
      </div>
      <br />
    </div>
